import NmsPolicyModel from './NmsPolicyModel';

class NmsPolicyTemplateModel extends NmsPolicyModel {
  get isTemplate() {
    return true;
  }

  createPolicyModel() {
    return this.clonePolicy({ enabled: true });
  }
}

export default NmsPolicyTemplateModel;
